export const LOGIN_STATUS_MESSAGES = {
    checking: "Checking if you're already signed in...",
    redirectSignUp: "Redirecting to sign up...",
} as const;

export type AuthStartOptions = {
    register?: boolean;
};

/**
 * Build /auth/social start URL.
 * Log In uses interactive OAuth so Authentickated can reuse an existing
 * session or show the sign-in form. Sign Up adds register=1.
 */
export const buildAuthStartUrl = (options: AuthStartOptions = {}): string => {
    const params = new URLSearchParams();
    params.set("start", "authentickated");

    if (options.register) {
        params.set("register", "1");
    }

    return `/auth/social?${params.toString()}`;
};
